import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from 'App'
import { AuthProvider } from 'auth/AuthContext'
import { DensityProvider } from 'components/app-shell/context/DensityContext'
import { RegionProvider } from 'components/app-shell/context/RegionContext'
import { ThemeProvider } from 'components/app-shell/context/ThemeContext'
import { ConfirmProvider } from 'components/Confirm'
import { ErrorBoundary } from 'components/ErrorBoundary'
import { ToastProvider } from 'components/Toast'

import 'styles/tokens/tokens.css'
import 'styles/index.css'
import 'styles/app-shell.css'
import 'styles/auth.css'
import 'styles/print.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <ThemeProvider>
          <RegionProvider>
            <DensityProvider>
              <ToastProvider>
                <ConfirmProvider>
                  <AuthProvider>
                    <App />
                  </AuthProvider>
                </ConfirmProvider>
              </ToastProvider>
            </DensityProvider>
          </RegionProvider>
        </ThemeProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
)
